(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["job-application-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('job-application-root');
    if (!root) return;

    var apiUrl = root.dataset.apiUrl;
    var labelOpen = root.dataset.labelOpen || 'Apply for this role';
    var labelClose = root.dataset.labelClose || 'Hide application form';
    var toggleBtn = document.getElementById('job-application-toggle');
    var panel = document.getElementById('job-application-panel');
    var form = document.getElementById('job-application-form');
    var statusEl = document.getElementById('job-application-status');
    var submitBtn = document.getElementById('job-application-submit');

    if (toggleBtn && panel) {
      toggleBtn.addEventListener('click', function () {
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        toggleBtn.textContent = isOpen ? labelOpen : labelClose;
        if (!isOpen) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var firstField = document.getElementById('job-app-name');
          if (firstField) firstField.focus();
        }
      });
    }

    if (!form || !apiUrl) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      statusEl.textContent = '';
      submitBtn.disabled = true;

      fetch(apiUrl, {
        method: 'POST',
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            return { ok: response.ok, body: body };
          });
        })
        .then(function (result) {
          if (result.ok && result.body.ok) {
            form.reset();
            statusEl.textContent = 'Thank you — your application has been submitted.';
            return;
          }
          var message = (result.body && result.body.error && result.body.error.message)
            || 'Something went wrong. Please try again.';
          statusEl.textContent = message;
        })
        .catch(function () {
          statusEl.textContent = 'Could not submit your application. Please try again later.';
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
